// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IReviewRateFilterSchema } from './ReviewRateFilterSchema';

export interface IGetReviewsWebRequestSchema {
  /** Фильтры **/
  filters?: IReviewRateFilterSchema[] | null;
  /** Загрузить все отзывы **/
  getAllItems?: boolean | null;
  /** id ЖК **/
  newbuildingId: number;
  /** Пагинация **/
  page?: number | null;
  /** Сортировка **/
  sort?: ESort | null;
  /** Фильтр по тегу **/
  tag?: ETag | null;
}
export enum ESort {
  /** По дате (сначала новые) **/
  'By_date_asc' = 'by_date_asc',
  /** По дате (сначала старые) **/
  'By_date_desc' = 'by_date_desc',
  /** По оценке (сначала низкая) **/
  'By_rating_asc' = 'by_rating_asc',
  /** По оценке (сначала высокая) **/
  'By_rating_desc' = 'by_rating_desc',
  /** По умолчанию **/
  'Default' = 'default',
}
export enum ETag {
  /** Придомовая территория **/
  'Adjoining_territory' = 'adjoining_territory',
  /** Строительство **/
  'Construction' = 'construction',
  /** Застройщик **/
  'Developer' = 'developer',
  /** Район **/
  'District' = 'district',
  /** Отделка **/
  'Flat' = 'flat',
  /** Дом **/
  'House' = 'house',
  /** Инфраструктура **/
  'Infrastructure' = 'infrastructure',
  /** Дети **/
  'Kids' = 'kids',
  /** управляющая компания **/
  'Management_company' = 'management_company',
  /** Парковка **/
  'Parking' = 'parking',
  /** Покупка **/
  'Purchase' = 'purchase',
  /** Транспортная доступность **/
  'Transport_affordable' = 'transport_affordable',
}
